import React, {useEffect, useState} from 'react';
import { Link, useParams } from "react-router-dom";

import AppContext from "../../app-context";
import {socketUseEffect} from "../../socket";

import PageTitle from "../core/page-title";

import SideBar from "../core/dashboards/sidebar";
import MainDashboardContent from "../core/dashboards/section"

import Dashboard from "./sub-pages/wordpress/dashboard";
import Themes from "./sub-pages/wordpress/themes";
import Plugins from "./sub-pages/wordpress/plugins";
import {useAuth} from "../../AuthContext";
import {IconLayoutDashboard, IconPalette, IconPlug, IconEdit, IconTrash} from "@tabler/icons-react";
import Servers from "./servers";
import Wordpress from "./wordpress";

const WordPressDashboard = (props) => {
    const [details, setDetails] = useState({name: "Loading..."})
    const { id, page } = useParams();

    const [refresh, setRefresh] = useState(true);

    const { user } = useAuth();
    const listeners = [
        {name: "wordpress", fn: "get", args: {user_id: user.user_id, id: id}, saveDataFN: setDetails, row: "0"},
    ]
    useEffect(() => socketUseEffect(listeners, user), [id, page, refresh]);



    let sort = [
        {label: "Status", column: "status",},
        {label: "Name", column: "name",},
        {label: "Created Date", column: "created_date",},
    ]

    let tabs = [
        { label: "Dashboard", page: "dashboard", link: "/wordpress/:id/dashboard", controller: Dashboard },
        { label: "Plugins", page: "plugins", link: "/wordpress/:id/plugins", controller: Plugins },
        { label: "Themes", page: "themes", link: "/wordpress/:id/themes", controller: Themes },
        { label: "Edit", page: "edit", link: "/wordpress/:id/edit", controller: Wordpress, args: {edit: 1, id, details, refresh, setRefresh} },
        { label: "Remove", page: "delete", link: "/wordpress/:id/delete", controller: Wordpress, args: {delete: 1, id, details, refresh, setRefresh} },
    ];

    const icons = {
        dashboard: <IconLayoutDashboard size={20} />, // Profile Icon
        themes: <IconPalette size={20} />, // Followers Icon
        plugins: <IconPlug size={20} />, // Friends Icon
        edit: <IconEdit size={20} />, // Friends Icon
        delete: <IconTrash size={20} />, // Friends Icon
    };

    return (
        <>
            <PageTitle
                title={<>WordPress: {details.name === "Loading..." ? <span className="loading-text">Loading...</span> : details.name}</>}
                homeUrl={"/dashboard"} subTitle={"Details"}
                links={[{ name: "WordPress", link: "/wordpress" }]}
                menuItems={tabs}
                menuIcons={icons}
                curPage={page}
                curID={id}
            />

            <div class={"card overflow-hidden invoice-application"}>
                <div className="d-flex">
                    <div className="w-25 d-none d-lg-block border-end user-chat-box">
                        <div className="app-invoice">
                            <ul className="overflow-auto invoice-users simplebar-scrollable-y" data-simplebar="init">
                                <div className="simplebar-wrapper" style={{margin: "0px"}}>
                                    <div className="simplebar-height-auto-observer-wrapper">
                                        <div className="simplebar-height-auto-observer"></div>
                                    </div>
                                    <div className="simplebar-mask">
                                        <div className="simplebar-offset" style={{right: "0px", bottom: "0px"}}>
                                            <div className="simplebar-content-wrapper" tabIndex="0" role="region"
                                                 aria-label="scrollable content"
                                                 style={{height: "100%", overflow: "hidden scroll"}}>
                                                <div className="simplebar-content" style={{padding: "0px"}}>
                                                    <SideBar id={id} sort={sort} object={"wordpress"} path={"wordpress"}  controller={Wordpress} refresh={refresh} setRefresh={setRefresh}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="simplebar-placeholder" style={{width: "280px", height: "459px"}}></div>
                                </div>
                                <div className="simplebar-track simplebar-horizontal" style={{visibility: "hidden"}}>
                                    <div className="simplebar-scrollbar" style={{width: "0px", display: "none"}}></div>
                                </div>
                                <div className="simplebar-track simplebar-vertical" style={{visibility: "visible"}}>
                                    <div className="simplebar-scrollbar"
                                         style={{height: "25px", display: "block", transform: "translate3d(0px, 0px, 0px)"}}></div>
                                </div>
                            </ul>
                        </div>
                    </div>
                    <div className="w-75 w-xs-100 chat-container">
                        <div className="invoice-inner-part h-100">
                            <div className="invoiceing-box">
                                <div id="custom-invoice">
                                    <MainDashboardContent tabs={tabs} page={page} id={id} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default WordPressDashboard;
